import React from 'react';
import styled from 'styled-components';
import {Button} from 'components/antd';
import Modal from 'react-modal';
import {Cross} from 'components/Ui/Icon';
import {useUnarchiveProspectPoolMutation, ProspectPool} from 'api';

interface Props {
  prospectPool: ProspectPool;
  isModalVisible: boolean;
  setIsModalVisible: (isModalVisible: boolean) => void;
}

export default ({prospectPool, isModalVisible, setIsModalVisible}: Props) => {
  const [unarchiveProspectPool, {loading}] = useUnarchiveProspectPoolMutation({
    variables: {
      uuid: prospectPool.uuid,
    },
    onCompleted: () => {
      setIsModalVisible(false);
    },
  });

  const onClose = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      isOpen={isModalVisible}
      onRequestClose={() => onClose()}
      style={customStyles}>
      <Header>
        <CrossIconWrapper onClick={() => setIsModalVisible(false)}>
          <Cross />
        </CrossIconWrapper>
      </Header>
      <Body>アーカイブを復元しますか？</Body>
      <Footer>
        <Button type="ghost" onClick={() => setIsModalVisible(false)}>
          キャンセル
        </Button>
        <Button
          type="primary"
          onClick={() => unarchiveProspectPool()}
          disabled={loading}>
          復元
        </Button>
      </Footer>
    </Modal>
  );
};

const customStyles = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 100,
  },
  content: {
    top: '400px',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '466px',
    height: '215px',
    padding: '0',
    borderRadius: '5px',
    overflow: 'hidden',
  },
};

const Header = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 30px;
`;

const CrossIconWrapper = styled.div`
  cursor: pointer;
  position: relative;
  top: 15px;
  right: 20px;
`;

const Body = styled.div`
  text-align: center;
  margin-bottom: 40px;
  font-weight: 700;
  font-size: 16px;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  .ant-btn {
    width: 100px;
  }
`;
